module.exports = __webpack_public_path__ + "img/1536433781.d157eae3.jpg";